interface formElements {
    type?: string;
    inputType?: string;
    model?: string;
    label?: string;
    required?: boolean;
    labelId?: string;
    size?: string;
}


interface FormField {
    automaticSort?:boolean;
    boxLabel?:string;
    borderClass?: string;
    boxBackground?:string;
    boxBorder?:string;
    boxBorderRadius?:string;
    boxFontSize?:string;
    boxInput?:string;
    boxPadding?:string;
    boxTop?:string;
    buttonClass?: string;
    buttonLabel?:string;
    checkBoxCheck?: string;
    checkBoxUncheck?: string;
    checkBoxText?:string;
    checkBoxType?: string;
    checkIt?: boolean;
    class?: string;
    className?:string;
    cols?: number;
    colorContent?:string;
    containerClass?: string;
    dateformat?:string;
    direction?: string;
    disabled?:boolean | (() => boolean);
    elementAsterisk?:boolean;
    elements?: formElements;
    errorShow?: boolean;
    errorText?: string | string[];
    fileHint?: string;
    fileModel?: string;
    fileUpload?: string;
    findForProof?: string;
    flexJustify?: string;
    fontFamily?:string;
    format?: string;
    freeText?:string;
    freeTextType?: string;
    hinted?: string|  (() => string);
    id?:string;
    idLabel?:string;
    inline?:boolean;
    inputType?: string;
    label?: string;
    labelElement?:string;
    labelAsterisk?:boolean;
    marginBetween?:string;
    maxcount?: number;
    maxlength?:number;
    maxSize?: number;
    min?:number;
    model?: string;
    onclick?:any;
    overflow?:boolean;
    placeholder1? :string;
    placeholder2?:string;
    radioType?:string;
    range?:boolean;
    required?: boolean;
    row?:number;
    size?: string;
    switchFont?:string;
    switchBorderRadius?: string;
    switchBoxShadow?:string;
    switchWidth?:string;
    switchHeight?: string;
    switchGrey?:string;
    switchOn?:string;
    text?: string;
    textOn?:string;
    textOff?:string;
    type: string;
    url?: string;
    validator?: string[];
    validatorText?: string;
    valueAllJobs?: Record<string,any>;
    valueAllSectors?: Record<string,any>;
    values?: { id: any; name: string }[];
    visible?: boolean |  (() => boolean);
    webSiteDoc?:string;
    onChange?: () => void;
    buttons?: {
        visible?: boolean |  (() => boolean);
        type?: string;
        text?: string;
        class?: string;
        label?:string;
        pType?: string;
        buttonWidth: string[],
        id?:string;
        onclick?: {
            functionVal: string;
            argumentsVal: string[];
        };
    };
}

export interface FormSchema {
    fields: FormField[];
}


export function schemaFunc(): FormSchema {
    let schema = {
        fields: [
            //breakline
            {   
                type: 'breakLine',
            },
            //Button
            {
                type:'button',
                disabled: true,
                buttonLabel: 'testButton',
                buttonClass: 'btn btn-secondary',
                hinted: 'ButtonSingle',
                label: 'Button Single',
                class: 'ButtonFull',
                onclick: {
                    'functionVal': "produceButton",
                    'argumentsVal': ['product', 'neues Produkt']
                }
            },
            // button group
            {
                type: 'buttonGroup',
                direction: 'horizontical',
                cols: 2,
                disabled: false,
                label: 'ButtonGroup',
                visible: true,
                hinted: 'ButtonGroup',
                buttons: [
                    {
                        class: 'btn btn-success',
                        label: 'buttonGroup 1',
                        hinted: 'Button Multi',
                        disabled: true,
                        onclick: {
                            'functionVal': "produceButton Group1",
                            'argumentsVal': ['product', 'neues Produkt']
                        },
                    },
                    {
                        class: 'btn btn-dark',
                        label: 'buttonGroup 2',
                        hinted: 'Button Multi',
                        disabled: false,
                        onclick: {
                            'functionVal': "produceButton Group2",
                            'argumentsVal': ['product', 'neues Produkt']
                        }
                    }
                ]
            },
            //checkbox single
            {
                type: 'checkbox',
                model: 'newFile',
                boxLabel: 'Ich erkläre mich damit einverstanden, dass im Rahmen der Veranstaltung Foto- und Videoaufnahmen von mir gemacht werden. Die Aufnahmen dürfen im Zusammenhang mit der Veranstaltung veröffentlicht und verwendet werden. Ich erkläre mich damit einverstanden, dass im Rahmen der Veranstaltung Foto- und Videoaufnahmen von mir gemacht werden. Die Aufnahmen dürfen im Zusammenhang mit der Veranstaltung veröffentlicht und verwendet werden. Ich erkläre mich damit einverstanden, dass im Rahmen der Veranstaltung Foto- und Videoaufnahmen von mir gemacht werden. Die Aufnahmen dürfen im Zusammenhang mit der Veranstaltung veröffentlicht und verwendet werden.',
                borderClass: 'checkBorderClass',
                label: 'Single Checkbox',
                class: 'myStyleComp',
                required: true,
                errorShow: false,
                errorText: '',
                validator: ['checkCheckBox'],
                validatorText: 'einen Vornamen',
                disabled: false,
                hinted: 'Checkbox Single',
                visible: true,
                boxBorder: '1px solid blue',
                boxPadding: '1px 3px',
                boxBackground: 'white',
                boxBorderRadius: '3',
                boxInput: 'none', //inline-block by custom
                boxFontSize: '10px',
                boxTop: '-7',
                colorContent: 'red',
                checkBoxType: 'squareHook', //squareRound, squareAngular, squareHook, squareCross, custom,
                marginBetween: '10px',
                checkBoxText: 'col-11'
            },
            //checkList
            {
                type: 'checklist',
                label: 'Check List',
                model: 'csvFields',
                class: 'checkListClass',
                values: [
                    {id: 'busshuttle', name: 'Ich erkläre mich damit einverstanden, dass im Rahmen der Veranstaltung Foto- und Videoaufnahmen von mir gemacht werden. Die Aufnahmen dürfen im Zusammenhang mit der Veranstaltung veröffentlicht und verwendet werden. Ich erkläre mich damit einverstanden, dass im Rahmen der Veranstaltung Foto- und Videoaufnahmen von mir gemacht werden. Die Aufnahmen dürfen im Zusammenhang mit der Veranstaltung veröffentlicht und verwendet werden. Ich erkläre mich damit einverstanden, dass im Rahmen der Veranstaltung Foto- und Videoaufnahmen von mir gemacht werden. Die Aufnahmen dürfen im Zusammenhang mit der Veranstaltung veröffentlicht und verwendet werden.'},
                    {id: 'city_vis', name: 'city_vis'},
                    {id: 'company_vis', name: 'company_vis'},
                    {id: 'country_vis', name: 'country_vis'},
                    {id: 'email', name: 'email'},
                    {id: 'fChildrenName', name: 'fChildrenName'},
                    {id: 'fVisitorName', name: 'fVisitorName'},
                    {id: 'firstname_vis', name: 'firstname_vis'},
                    {id: 'housenumber_vis', name: 'housenumber_vis'},
                    {id: 'lastname_vis', name: 'lastname_vis'},
                    {id: 'otherTitle_vis', name: 'otherTitle_vis'},
                    {id: 'postalcode_vis', name: 'postalcode_vis'},
                    {id: 'regStatus', name: 'regStatus'},
                    {id: 'salutation_vis', name: 'salutation_vis'},
                    {id: 'societyName', name: 'societyName'},
                    {id: 'street_vis', name: 'street_vis'},
                    {id: 'telefon', name: 'telefon'},
                    {id: 'title_vis', name: 'title_vis'}
                ],
                required: true,
                errorShow: false,
                errorText: '',
                validator: ['checkMultiCheckBox'],
                validatorText: 'einen Vornamen',
                visible:true,
                disabled: false,
                hinted: 'Checklist',
                inline: false,
                overflow: true,
                size: "col-4",
                flexJustify: 'flex-start',
                automaticSort: false,
                containerClass: 'checkListCSV',
                checkBoxType: 'squareHook',                    
                boxBorder: '1px solid rgb(227,6,9)',
                boxPadding: '3px 3px 1px 3px',
                boxBackground: 'white',
                boxBorderRadius: '3',
                boxInput: 'none', //inline-block by custom
                boxFontSize: '13px',
                boxTop: '-1',
                colorContent: 'rgb(227,6,9)',
                marginBetween: '10px',
                checkBoxText: 'col-11',
                buttons: {
                    type: 'text',
                    text: 'neues Produkt',
                    class: 'btn btn-primary',
                    visible: true,
                    onclick: {
                        'functionVal': "produceParams",
                        'argumentsVal': ['product', 'neues Produkt']
                    }
                },
            },
            //current Files
            {
                type: 'currentFiles',
                model: 'currentFiles',
                label: 'Aktuelle Dateien',
                class: 'currentFiles',
                automaticSort: true,
                visible: true,
            },
            // datetime picker
            {
                type: 'datetimepicker',
                label: 'Beginn der Veranstaltung',
                model: 'startdate',
                // format: 'YYYY-MM-DD HH:mm:ss',
                format: 'YYYY-MM-DD HH:mm:ss',
                dateformat: 'datetime',
                required: true,
                errorShow: false,
                errorText: '',
                validator: ['checkInput'],
                validatorText: 'den Beginn der Veranstaltung',
                visible:true,
                disabled: false,
                range: false,
                hinted: 'Datetimepicker'
            },
            //double Input
            {
                type: 'doubleInput',
                disabled: true,
                hinted: 'Double Input',
                model: 'streetHn',
                required: true,
                errorShow: false,
                errorText: '',
                validator: ['checkDoubleInput'],
                validatorText: 'Ihre Straße und Ihre Hausnummer',
                visible:true,
                label: 'Double Input',
                elements: [
                    // street
                    {
                        type: 'input',
                        inputType: 'text',
                        model: 'street',
                        label: 'Straße',
                        required: true,
                        labelId: 'labelStreet',
                        size: 'col-8',
                    },
                    //housenumber
                    {
                        type: 'input',
                        label: 'Hausnummer',
                        inputType: 'text',
                        model: 'housenumber',
                        labelId: 'labelHn',
                        required: true,
                        size: 'col-4'                           
                    },
                ],
            },
            //doubleInput VFor
            {
                type: 'doubleInputVFor',
                label: 'doubleInputVFor',
                model: 'fChildrenName',
                placeholder1: 'Name',
                placeholder2: 'Alter',
                labelElement: 'Kind', 
                required: true,
                errorShow: false,
                errorText: '',
                validator: ['checkDoubleInputVFor'],
                validatorText: 'Bitte geben Sie den Namen und das Alter des Kindes an',
                hinted: 'doubleInputVFor',       
                visible: true,
                disabled: true,
            },
            //treeSelect
            {
                type: 'treeSelect',
                class: 'treeSelectClass',
                values: [
                    {
                        "id":7,"label":"Ernährung / Hauswirtschaft / Lebensmittel", "children" : [
                            {
                                "id":[7,1],
                                "label":"Amtliche Fachassistent (w/m/d) in der Veterinärverwaltung (Rot- und Weißfleisch)", 
                                "customLabel": "Ernährung / Hauswirtschaft / Lebensmittel => Amtliche Fachassistent (w/m/d) in der Veterinärverwaltung (Rot- und Weißfleisch)"
                            }
                        ]
                    },
                    {
                        "id":12,"label":"Gesundheit / Sport / Pflege", "children" : [
                            {"id":[12,2],"label":"Anästhesietechnische Assistenz (w/m/d)",
                                "customLabel": "Gesundheit / Sport / Pflege => Anästhesietechnische Assistenz (w/m/d)"
                            }
                        ]
                    },
                    {
                        "id":20,"label":"Metalltechnik","children": [
                             {"id":[20,238],"label":"Anlagenmechaniker (w/m/d)",
                                "customLabel": "Metalltechnik => Anlagenmechaniker (w/m/d)"
                             }
                        ]
                    }
                ],
                mainLabel: 'Ausbildungsberuf',
                model: 'jobSector',
                label: 'TreeSelect',
                validator: ['checkSelectJob'],
                required: true,
                errorShow: false,
                errorText: '',  
                hinted: 'treeselect',
                visible: true,
                disabled: false,
                placeholder: "Bitte den Ausbildungsberuf auswählen",
                multiselect: false,
                arrowClass: 'myOwnArrowClass',
                iconClose: 'fa-solid fa-exclamation',
                iconOpen: 'fa-solid fa-check'
            },
            //fileUpload
            {
                type: 'fileUpload',
                model: 'filename',
                fileModel: 'fileData',
                required: true,
                validator: ['checkFileUploadDesigned'],
                validatorText: '',
                errorShow: false,
                errorText: '',
                label: 'File Upload',
                idLabel: 'fileUploadBBS',
                hinted: 'FileUpload',
                visible:true,
                disabled: false,
            },            
            //fileUploadHint
            {
                type: 'fileUploadHint',
                label: 'File Upload Hint',
                model: 'files',
                fileUpload: 'filesUpload',
                validator: ['checkFileUpload'],
                validatorText: '',
                disabled: true,
                required: true,
                findForProof: 'docType',
                errorShow: false,
                errorText: [],
                hinted: 'FileUploadHint',
                fileHint:   '<ul>'+
                                '<li>Es wird <u>immer</u> ein _WEB.pdf benötigt!</li>'+
                                '<li>Für die Preview-Ansicht brauchen Sie keine JPG-Dateien hochladen, diese werden automatisch generiert.</li>'+
                                '<li>Wichtig ist, dass jede PDF-Datei einen entsprechenden Appendix im Dateinamen hat:<br>Beispiel: <i>name-der-datei_WEB.pdf</i>'+
                                '<li> Folgende Appendizes sind bisher im Gebrauch:<br>'+
                                    '<br>PDF:</br>'+
                                    '<ul>'+
                                    '<li>_WEB</li>'+
                                    '<li>_EDIT</li>'+
                                    '<li>_PRINT</li>'+
                                    '<li>_SW-WEB</li>'+
                                    '<li>_SW-OHNE-WEB</li>'+
                                    '<li>_MUSTER-WEB</li>'+
                                    '<li>_SELBSTAUSDRUCK'+
                                    '</ul>'+
                                    '<br>Office-Dateien:<br>'+
                                    '<ul>'+
                                        '<li>Word-Dokumente: _DOCX</li>'+
                                        '<li>Excel-Dokumente: _XLSX</li>'+
                                        '<li>PowerPoint-Dokumente: _PPTX</li>'+
                                    '</ul>'+
                                    '<br>Grafik-Dateien:<br>'+
                                    '<ul>'+
                                        '<li>SVG-Dateien: _SVG</li>'+
                                    '</ul>'+
                                    '<br>Hochauflösende JPG-Dateien:<br>'+
                                    '<ul>'+
                                        '<li>_WEB- plus der Nummer der Seite: z.B. <i>name-der-datei_WEB-1.jpg</i></li>'+
                                    '</ul><br>'+
                                '</li>'+
                                '<li>Bitte beachten Sie auch, dass alle Präfixe gleich lauten und sich keine Leerzeichen, Umlaute oder Sonderzeichen im Dateinamen befinden.</li>'+
                            '</ul>'
                ,
                visible: true
            },
            //fileUploadSingle
            {
                type: 'fileUploadSingle',
                label: 'File Upload Single',
                model: 'sendCorrFile',
                fileUpload: 'requestFileUpload',
                validator: ['checkRequestFile'],
                validatorText: 'eine Datei',
                hinted: 'Folgende Dateitypen können Sie Versenden: PDF, docx (Word), pptx (PowerPoint). Bitte beachten Sie, dass die Dategröße nicht mehr als 20 MB beträgt.',
                errorShow: false,
                errorText: '',
                maxSize: 20,
                checkIt: true,
                visible: true,
                disabled: true
            },
            //freetext
            {
                type: 'freeText',
                label: 'Label für Freetext',
                freeTextType: 'withModelLabel', // blank, withLabel, withModel, withModelLabel,
                model: 'freeText',
                freeText: 'Ein freier Text',
                id: 'freeTextTest',
                hinted: 'FreeText'
            },
            //furtherEmail
            {
                type: 'furtherEmail',
                label: 'Further Email',
                model: 'furtherEmailReceiver',
                visible: true,
                hinted: 'Further Email',
                disabled: false,
                required: true,
                errorShow: false,
                errorText: '',  
                validator: ['checkEmailFurther'],
            },
            //furtherEmail
            {
                type: 'furtherEmail',
                label: 'E-Mail-Adressen',
                model: 'paramEmailArr',
                required: true,
                errorShow: false,
                errorText: '',  
                validator: ['checkEmailFurther'],
                visible:true
            },
            //furtherJob
            {
                type: 'furtherJobs',
                model: 'furtherJobs',
                label: 'Further Jobs',
                hinted: 'FurtherJobs',
                direction: 'horizontical',
                required: true,
                errorShow: false,
                errorText: '',  
                validator: ['checkFurtherJobs'],
                visible: true,
                disabled: false,
            },
            //furtherVisitor
            {
                type: 'fVisitor',
                label: 'fVisitor',
                maxcount: 3,
                model: 'fVisitor',
                required: true,
                errorShow: false,
                errorText: '',
                validator: ['checkFVisitor'],
                validatorText: 'einen Vornamen',
                visible: true,
                disabled: true,
                hinted: 'fVisitor'

            },
            //Headline
            {
                type: 'headLine',
                text: 'Headline',
                size: 'h4'
            },
            // Group Function                    
            { 
                type: 'groupFunction',
                label: 'Dokumentenparameter',
                model: 'groupFunction',
                direction: 'horizontical',
                visible: true,
                elements: [ 
                    //docCategory disabled
                    {
                        type: 'select',
                        model: 'docCategory',
                        label: 'Kategorie',
                        disabled: false,
                        size: 2,
                        values: [
                            {id: 1, name: 'test'}
                        ],
                    },
                    //docNetLocation disabled
                    {
                        type: 'select',
                        values: [
                            {id: 1, name: 'test'}
                        ],
                        model: 'docNetLocation',
                        size: 2,
                        label: 'Netzgebiet',
                        disabled: true,
                    },
                    //docInventarNumber disabled
                    {
                        type: 'input',
                        inputType: 'text',
                        model: 'docInventarNumber',
                        size: 2,
                        label: 'Dokumentennummer',
                        disabled: true,
                    },
                    //docVersionNumber disabled
                    {
                        type: 'input',
                        inputType: 'text',
                        model: 'docVersionNumber',
                        label: 'Versionsnummer',
                        size: 2,
                        disabled: true,
                    }
                ],
            },
            //HR
            {
                type: 'horizonticalLine',
                visible: true
            },
            //Input
            {
                type: 'input',
                inputType: 'text',
                model: 'firstname',
                label: 'Input Main',
                disabled: false,
                required: true,
                errorShow: false,
                errorText: '',
                validator: ['checkInput'],
                validatorText: 'einen Vornamen',
                hinted: 'Input Main'
            },
            //Input passwort
            {
                type: 'input',
                inputType: 'password',
                min: 8,
                required: true,
                hinted: 'Mindestens 8 Zeichen, davon einen Gro&szlig;buchstaben und ein Sonderzeichen',
                model: 'password',
                label: 'Input password',
                validator: ['checkPassword'],
                id: 'passwordOne',
                errorShow: false,
                errorText: '',
                buttons: {
                    type: 'showPassword',
                    id: 'pType1',
                    pType: 'password',
                    buttonWidth: [11,1]
                }
            },
            // input with button
            {
                type: 'input',
                label: 'Input Button',
                model: 'product',
                values: [],
                hinted: 'Input Button',
                required: true,
                errorShow: false,
                errorText: '',
                validator: ['checkInput'],
                validatorText: 'einen Vornamen',
                buttons: {
                    type: 'text',
                    text: 'neues Produkt',
                    class: 'btn btn-primary',
                    visible: true,
                    buttonWidth: [9,3],
                    onclick: {
                        'functionVal': "produceParams",
                        'argumentsVal': ['product', 'neues Produkt']
                    }
                },
            }, 
            //input FEmail
            {
                type: 'inputFEmail',
                inputType: 'text', 
                model: 'emailReceiverFurther',
                hinted: '(Mehrere Empfänger bitte durch Kommata trennen)',
                label: 'input FEmail',
                validator: ['checkInputFEmail'],
                validatorText: 'einen Empfänger',
                errorShow: false,
                errorText: '',
                checkIt: true,
                visible: true,
                disabled: false
            },
            //preview
            {
                type: 'preview',
                model: 'previewText',
                hinted: 'preview',
                label: 'preview',
                visible: true,
            },
            //radio
            {               
                type: 'radio',
                label: 'Radio-Field',
                model: 'swbWebType',
                idLabel: 'swbTypeId',
                required: true,
                validator: ['checkRadio'],
                validatorText: 'eine Datei', 
                errorShow: false,
                errorText: '',
                values: [
                    {id: 0, name: 'Ich erkläre mich damit einverstanden, dass im Rahmen der Veranstaltung Foto- und Videoaufnahmen von mir gemacht werden. Die Aufnahmen dürfen im Zusammenhang mit der Veranstaltung veröffentlicht und verwendet werden. Ich erkläre mich damit einverstanden, dass im Rahmen der Veranstaltung Foto- und Videoaufnahmen von mir gemacht werden. Die Aufnahmen dürfen im Zusammenhang mit der Veranstaltung veröffentlicht und verwendet werden. Ich erkläre mich damit einverstanden, dass im Rahmen der Veranstaltung Foto- und Videoaufnahmen von mir gemacht werden. Die Aufnahmen dürfen im Zusammenhang mit der Veranstaltung veröffentlicht und verwendet werden.'},
                    {id: 1, name: 'test2'},
                    {id: 2, name: 'test3'},
                ],
                visible: true,
                disabled: false,
                hinted: 'radio field',
                inline: false,
                overflow: true,
                size: "col-4",
                flexJustify: 'flex-start',
                containerClass: 'checkListCSV',
                radioType: 'round', //squareHook, squareCross, round
                boxBorder: '1px solid rgb(227,6,9)',
                boxPadding: '3px 3px 1px 3px',
                boxBackground: 'white',
                boxBorderRadius: '3',
                boxFontSize: '13px',
                boxTop: '-1',
                colorContent: 'rgb(227,6,9)',
                marginBetween: '10px',
                checkBoxText: 'col-11',
                labelAsterisk: true,
                elementAsterisk: false
            }, 
            //radio
            {               
                type: 'radio',
                label: 'Radio-Field Single',
                model: 'swbWebType',
                idLabel: 'swbTypeId',
                required: true,
                validator: ['checkRadio'],
                validatorText: 'eine Datei', 
                errorShow: false,
                labelAsterisk: true,
                elementAsteriks: false,
                errorText: '',
                values: [
                    {id: 0, name: 'Ich erkläre mich damit einverstanden, dass im Rahmen der Veranstaltung Foto- und Videoaufnahmen von mir gemacht werden. Die Aufnahmen dürfen im Zusammenhang mit der Veranstaltung veröffentlicht und verwendet werden. Ich erkläre mich damit einverstanden, dass im Rahmen der Veranstaltung Foto- und Videoaufnahmen von mir gemacht werden. Die Aufnahmen dürfen im Zusammenhang mit der Veranstaltung veröffentlicht und verwendet werden. Ich erkläre mich damit einverstanden, dass im Rahmen der Veranstaltung Foto- und Videoaufnahmen von mir gemacht werden. Die Aufnahmen dürfen im Zusammenhang mit der Veranstaltung veröffentlicht und verwendet werden.'},
                ],
                visible: true,
                disabled: false,
                hinted: 'radio field',
                inline: false,
                overflow: true,
                size: "col-4",
                flexJustify: 'flex-start',
                containerClass: 'checkListCSV',
                radioType: 'squareHook', //squareHook, squareCross, round
                boxBorder: '1px solid rgb(227,6,9)',
                boxPadding: '3px 3px 1px 3px',
                boxBackground: 'white',
                boxBorderRadius: '3',
                boxFontSize: '13px',
                boxTop: '-1',
                colorContent: 'rgb(227,6,9)',
                marginBetween: '10px',
                checkBoxText: 'col-11',
            }, 
            //sectionJob
            {
                type: 'sectionJob',
                class: 'sectionJobClass',
                valueAllJobs: [
                    {"id": 0, "name": "Bitte auswählen"},
                    {"id":1,"name":"Amtliche Fachassistent (w/m/d) in der Veterinärverwaltung (Rot- und Weißfleisch)","sector":7},
                    {"id":2,"name":"Anästhesietechnische Assistenz (w/m/d)","sector":12},
                    {"id":238,"name":"Anlagenmechaniker (w/m/d)","sector":20}
                ],
                valueAllSectors: [
                    {"id": 0, "name": "Bitte auswählen"},
                    {"id":7,"name":"Ernährung / Hauswirtschaft / Lebensmittel"},
                    {"id":12,"name":"Gesundheit / Sport / Pflege"},
                    {"id":20,"name":"Metalltechnik"}
                ],
                firstLabel: 'Sparte',
                secondLabel: 'Ausbildungsberuf',
                mainLabel: 'Ausbildungsberuf',
                model: 'jobSector',
                label: 'SectionJob',
                validator: ['checkSelectJob'],
                required: true,
                errorShow: false,
                errorText: '',  
                hinted: 'SectionJob',
                visible: true,
                disabled: false
            },
            //sectionJobAccordion
            {
                type: 'sectionJobAccordion',
                class: 'sectionJobClass',
                valueAllJobs: [
                    {"id": 0, "name": "Bitte auswählen"},
                    {"id":1,"name":"Amtliche Fachassistent (w/m/d) in der Veterinärverwaltung (Rot- und Weißfleisch)","sector":7},
                    {"id":2,"name":"Anästhesietechnische Assistenz (w/m/d)","sector":12},
                    {"id":238,"name":"Anlagenmechaniker (w/m/d)","sector":20}
                ],
                valueAllSectors: [
                    {"id": 0, "name": "Bitte auswählen"},
                    {"id":7,"name":"Ernährung / Hauswirtschaft / Lebensmittel"},
                    {"id":12,"name":"Gesundheit / Sport / Pflege"},
                    {"id":20,"name":"Metalltechnik"}
                ],
                firstLabel: 'Sparte',
                secondLabel: 'Ausbildungsberuf',
                mainLabel: 'Ausbildungsberuf',
                model: 'jobSector',
                label: 'SectionJobAccordion',
                validator: ['checkSelectJob'],
                required: true,
                errorShow: false,
                errorText: '',  
                hinted: 'SectionJob',
                visible: true,
                disabled: false
            },
            //sectorProduct
            {
                type: 'sectorProduct',
                class: 'sectionJobClass',
                valueAllJobs: [
                    {"id": 0, "name": "Bitte auswählen"},
                    {"id":1,"name":"Amtliche Fachassistent (w/m/d) in der Veterinärverwaltung (Rot- und Weißfleisch)","sector":7, "client":1},
                    {"id":2,"name":"Anästhesietechnische Assistenz (w/m/d)","sector":12, "client":2},
                    {"id":238,"name":"Anlagenmechaniker (w/m/d)","sector":20, "client": 1}
                ],
                valueAllSectors: [
                    {"id": 0, "name": "Bitte auswählen"},
                    {"id":7,"name":"Ernährung / Hauswirtschaft / Lebensmittel"},
                    {"id":12,"name":"Gesundheit / Sport / Pflege"},
                    {"id":20,"name":"Metalltechnik"}
                ],
                firstLabel: 'Sparte',
                secondLabel: 'Produkt',
                mainLabel: 'Sparte/Product',
                firstSelectWidth: 'col-3',
                secondSelectWidth: 'col-5',
                direction: 'horizontical',
                model: 'doc2sector',
                label: 'sectorProduct',
                validator: ['checkSelectJob'],
                required: true,
                errorShow: false,
                errorText: '',  
                hinted: 'SectorProduct',
                visible: true,
                disabled: false
            },
            //select
            {
                type: 'select',
                label: 'Select',
                model: 'event',
                values: [
                    {id: 0, name: 'Bitte auswählen'},
                    {id: 'abc', name: 'abd'},
                    {id: 'cdf', name: 'dcfd'}
                ],
                required: true,
                errorShow: false,
                errorText: '',
                validator: ['checkSelect'],
                validatorText: 'eine Veranstaltung',
                visible:true,
                disabled: false,
                hinted: 'Select',
                buttons: {
                    type: 'text',
                    text: 'neues Produkt',
                    class: 'btn btn-primary',
                    onclick: {
                        'functionVal': "produceParams",
                        'argumentsVal': ['product', 'neues Produkt']
                    },
                    visible() {               
                        if (this) {
                            if (this && (this as any).docNetLocation === 2) return true
                        }
                        return false;
                    }
                },
            },
            //swbWebSiteTitle
            {
                type: 'webServiceData',
                label: 'webServiceData',
                validator: ['checkWnUpdate'],
                webSiteDoc: 'docFileName',
                url: 'wesernetz.de',
                required: true,
                errorShow: false,
                errorText: '',
                visible: true,
                disabled: true,
                hinted: 'webServiceData'
            }, 
            //switch
            {
                type: 'switch',
                label: 'Switch',
                model: 'swbWebUpdate',
                idLabel: 'swbWebUpdate',
                values: [
                    { id: 0, name: 'nein' },
                    { id: 1, name: 'ja' }
                ],
                textOff: 'Nein',
                textOn: 'Ja',
                visible:true,
                disabled: false,
                hinted: 'Switch',
                switchFont: 'Arial',
                switchWidth: '120',
                switchHeight: '30',
                switchBorderRadius: '15', //switchHeight / 2
                switchBoxShadow: 'inset 0 -1px white, inset 0 1px 1px rgba(0, 0, 0, 0.05);',
                switchGrey: 'rgb(119,109,99, 0.5)',
                switchOn: 'rgb(130, 188, 0)'
            },
            //textarea               
            {
                type: 'textarea',
                model: 'annotations',
                label: 'Textarea',
                row: 7,
                maxlength: 255,
                disabled: false,
                visible: true,
                hinted: 'Textarea',
                required: true,
                errorShow: false,
                errorText: '',
                validator: ['checkInput'],
                validatorText: 'einen Text',
            },
        ]
    }

    return schema as FormSchema;
}


